<template></template>

<script>
import eventBus from '~/plugins/event-bus';
import ActionComponent from './components/ActionComponent';

export default {
    name: 'MyToast',
    data() {
        return {
            defaulProperties: {
                message: 'Default message',
                position: 'bottom-center',
                type: 'default',
                timeout: 2000,
                closeButton: false,
                hideProgressBar: true,
            },
        };
    },
    methods: {
        initToast({
            message = this.defaulProperties.message,
            position = this.defaulProperties.position,
            type = this.defaulProperties.type,
            timeout = this.defaulProperties.timeout,
            closeButton = this.defaulProperties.closeButton,
            hideProgressBar = this.defaulProperties.hideProgressBar,
            actionProp = null
        }) {
            const actionPropInit = {
                component: ActionComponent,
                props: {
                    message: message,
                    buttonName: actionProp?.buttonName || null
                },
                listeners: {
                    action: () => actionProp.action()
                }
            }
            const toastPrimaryInitiator = actionProp ? actionPropInit : message

            this.$toast(
                toastPrimaryInitiator,
                {
                    message: message,
                    position: position,
                    type: type,
                    timeout: timeout,
                    icon: this.initIconLayout(type),
                    closeButton: closeButton,
                    hideProgressBar: hideProgressBar,
                }
            )
        },

        initIconLayout(type = 'default') {
            const iconId = {
                'default': 'supportIcon',
                'success': 'checkIcon',
                'failure': 'closeIcon',
            }

            return (
                <div>
                    <svg><use xlinkHref={this.iconLink(iconId[type])} /></svg>
                </div>
            )
        },
        iconLink(icon) {
            const spritePath = require('~/themes/novaporta/assets/icons/sprite.svg');
            return `${spritePath}#${icon}`;
        }
    },
    beforeMount() {
        eventBus.$on('show-toast', this.initToast);
    },
    beforeDestroy() {
        eventBus.$off('show-toast', this.initToast);
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
